import { Helmet } from "react-helmet-async"
import { useParams, useSearchParams } from "../../../router-utils"
import { PaymentPolicyItemDetails } from "../../../PaymentPolicy"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function PaymentPolicyItemPage() {
	const { paymentPolicyId } = useParams("/payment-policy/:paymentPolicyId")
	const [query] = useSearchParams()
	const detailName = query.get("name") || "Payment Policy"
	const isDisabled = query.has("is_deleted")
		? query.get("is_deleted") === "true"
		: undefined
	const isDefault = query.has("is_default")
		? query.get("is_default") === "true"
		: undefined
	const versionId = Number(query.get("version_id")) || undefined
	const version = Number(query.get("version")) || undefined

	return (
		<>
			<Helmet>
				<title>{detailName || "Payment Policy"}</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<PaymentPolicyItemDetails
					detailId={Number(paymentPolicyId)}
					detailName={detailName}
					isDisabled={isDisabled}
					isDefault={isDefault}
					versionId={versionId}
					version={version}
				/>
			</ForbidUnlessAuthorized>
		</>
	)
}
